export default "__VITE_ASSET__BzVVUjTn__"